import { DocumentURL, getHeaders, getQueryString, SubmissionURL } from 'services/config';
import { checkStatus } from 'services/normalizer';
import { Moment } from 'moment';
import { setTypes } from 'helpers/typeHelper';
import { AggregatePremiumData, AgentSummaryEntry, MonthlyBoundPremiumData } from '../types/dashboard.types';

export async function getDashboardAgentStateLocations(producerId?: string, productLineCode?: string) {
    const qs = getQueryString({ producerId, productLineCode });
    return fetch(`${SubmissionURL}/dashboard/agentstatelocations${qs}`, {
        method: 'GET',
        headers: getHeaders(),
    })
        .then(checkStatus)
        .then((resp) => resp.json());
}

export async function getSubmissionMapLocations(submissionId: string, productLineCode?: string) {
    const qs = getQueryString({ submissionId, productLineCode });
    return fetch(`${SubmissionURL}/dashboard/submissionlocations${qs}`, {
        method: 'GET',
        headers: getHeaders(),
    })
        .then(checkStatus)
        .then((resp) => resp.json());
}

export async function searchMapAddress(searchTerm: string, productLineCode?: string) {
    const qs = getQueryString({ searchTerm, productLineCode });
    return fetch(`${SubmissionURL}/dashboard/searchLocation${qs}`, {
        method: 'GET',
        headers: getHeaders(),
    })
        .then(checkStatus)
        .then((resp) => resp.json());
}

export async function getDashboardAgentLocations(producerId?: string, productLineCode?: string) {
    const qs = getQueryString({ producerId, productLineCode });
    return fetch(`${SubmissionURL}/dashboard/agentlocations${qs}`, {
        method: 'GET',
        headers: getHeaders(),
    })
        .then(checkStatus)
        .then((resp) => resp.json());
}

export async function getDashboardAgentQuotedLocations(producerId?: string, productLineCode?: string) {
    const qs = getQueryString({ producerId, productLineCode });
    return fetch(`${SubmissionURL}/dashboard/agentquotedlocations${qs}`, {
        method: 'GET',
        headers: getHeaders(),
    })
        .then(checkStatus)
        .then((resp) => resp.json());
}

export async function getDashboardAgentSubmittedLocations(producerId?: string) {
    const qs = getQueryString({ producerId });
    return fetch(`${SubmissionURL}/dashboard/agentsubmittedlocations${qs}`, {
        method: 'GET',
        headers: getHeaders(),
    })
        .then(checkStatus)
        .then((resp) => resp.json());
}

export async function getAgentBindRatios(producerId?: string) {
    const qs = getQueryString({ producerId });
    return fetch(`${SubmissionURL}/dashboard/agentbindratios${qs}`, {
        method: 'GET',
        headers: getHeaders(),
    })
        .then(checkStatus)
        .then((resp) => resp.json());
}

export async function getAgentSummary(producerId?: string, productLineCode?: string): Promise<AgentSummaryEntry[]> {
    const qs = getQueryString({ producerId, productLineCode });
    return fetch(`${SubmissionURL}/dashboard/agentsummary${qs}`, {
        method: 'GET',
        headers: getHeaders(),
    })
        .then(checkStatus)
        .then((resp) => resp.json());
}

export async function getAgentSubmissionLists(producerId?: string) {
    const qs = getQueryString({ producerId });
    return fetch(`${SubmissionURL}/dashboard/agentsubmissionlists${qs}`, {
        method: 'GET',
        headers: getHeaders(),
    })
        .then(checkStatus)
        .then((resp) => resp.json())
        .then(setTypes);
}

export async function getMonthlyBoundPremium(
    startDate: Moment,
    endDate: Moment,
    producerId?: string
): Promise<MonthlyBoundPremiumData[]> {
    const qs = getQueryString({
        startDate: startDate.format('YYYY-MM-DD'),
        endDate: endDate.format('YYYY-MM-DD'),
        producerId,
    });
    return fetch(`${SubmissionURL}/dashboard/agentmonthlypremium${qs}`, {
        method: 'GET',
        headers: getHeaders(),
    })
        .then(checkStatus)
        .then((resp) => resp.json());
}

export async function getAggregatePremiumData(
    programName: string,
    productLineCode?: string
): Promise<AggregatePremiumData> {
    const qs = getQueryString({ programName, productLineCode });
    return fetch(`${SubmissionURL}/aggregatePremiumData${qs}`, {
        method: 'GET',
        headers: getHeaders(),
    })
        .then(checkStatus)
        .then((resp) => resp.json());
}
